import { isValidPhoneNumber } from 'react-phone-number-input';

export const LEGAL_VERSION = 'commercial-beta-1.0-2026-09-21';

export const emptyProfileForm = () => ({
  firstName: '',
  lastName: '',
  phone: '',
  phoneCountry: '',
  companyName: '',
  accountType: '',
  legalAccepted: false,
});

export const validateProfileForm = (form) => {
  const errors = {};
  if (!form.firstName.trim()) errors.firstName = 'First name is required.';
  if (!form.lastName.trim()) errors.lastName = 'Last name is required.';
  if (!form.phone || !isValidPhoneNumber(form.phone)) {
    errors.phone = 'Enter a valid contact phone number.';
  }
  if (!['commercial', 'personal'].includes(form.accountType)) {
    errors.accountType = 'Choose Commercial or Personal.';
  }
  if (form.accountType === 'commercial' && !form.companyName.trim()) {
    errors.companyName = 'Company name is required for Commercial accounts.';
  }
  if (!form.legalAccepted) {
    errors.legalAccepted = 'You must accept the Terms and acknowledge the Privacy Notice.';
  }
  return errors;
};

export const validateSignupForm = (form) => {
  const errors = validateProfileForm(form);
  if (!String(form.email || '').trim()) errors.email = 'Email is required.';
  if (String(form.password || '').length < 8) {
    errors.password = 'Password must be at least 8 characters long.';
  }
  if (form.password !== form.confirmPassword) {
    errors.confirmPassword = 'Passwords do not match.';
  }
  return errors;
};

export const profilePayload = (form) => ({
  first_name: form.firstName.trim(),
  last_name: form.lastName.trim(),
  phone: form.phone,
  phone_country: form.phoneCountry || null,
  company_name: form.accountType === 'commercial' ? (form.companyName.trim() || null) : null,
  account_type: form.accountType,
  legal_accepted: form.legalAccepted === true,
});

export const formatApiError = (detail) => {
  if (!detail) return 'Something went wrong. Please try again.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map(item => item?.msg || String(item)).join(' ');
  if (typeof detail?.message === 'string') return detail.message;
  return 'Something went wrong. Please try again.';
};

export const profileReminderSessionKey = (session) => {
  const userId = session?.user?.id;
  const signedInAt = session?.user?.last_sign_in_at;
  if (!userId || !signedInAt) return null;
  return `aha-profile-reminder:${userId}:${signedInAt}:${LEGAL_VERSION}`;
};

export const shouldShowProfileReminder = ({ status, loading, dismissed, onProfilePage }) => (
  !loading && !dismissed && !onProfilePage && status?.available !== false && status?.reminder_required === true
);